import * as App from '../constants/app.constant'

export interface State {
  loading: boolean
  error: string
  success: string
}

export const initialState: State = {
  loading: false,
  error: '',
  success: '',
}

const app = (state: any = initialState, action: any) => {
  switch (action.type) {
    case App.SHOW_LOADING:
      return {
        ...state,
        loading: true,
      }
    case App.HIDE_LOADING:
      return {
        ...state,
        loading: false,
      }
    case App.SHOW_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case App.SHOW_SUCCESS:
      return {
        ...state,
        success: action.payload,
      }
    default:
      return state
  }
}

export default app



// WEBPACK FOOTER //
// ./src/reducers/app.reducer.ts